import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Toggle } from './index.js';
export const ToggleField = memo(function ToggleField(props) {
    const { input: { value, ...input }, meta: _meta, dataTestId, ...other } = props;
    return (_jsx(Toggle, { ...input, ...other, checked: !!value, dataTestId: dataTestId ? `${dataTestId}-checked-${!!value}` : `checked-${!!value}` }));
});
